// extracted by mini-css-extract-plugin
export var disabled = "_2r-5";
export var fileName = "_2r-b";
export var filePreview = "_2r-4";
export var hoverFilter = "_2r-6";
export var imageButton = "_2r-3 _2r-6";
export var imageButtonContainer = "_2r-2";
export var input = "_2r-7";
export var removeButton = "_2r-0";
export var removeButtonFile = "_2r-1";
export var spinner = "_2r-9";
export var spinnerContainer = "_2r-8";
export var videoContainer = "_2r-a _2r-6";